import React from "react";
import { View } from "react-native";
import { Button, InputLabel } from "components";

import { colors } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import css from "styles";

interface SelectableItemType {
  id?: number;
  title?: string;
  value?: string;
  price_ratio?: number;
}

interface SelectableItemListType {
  id?: number;
  title?: string;
  items?: Array<SelectableItemType>;
}

interface MultiSelectableItemType {
  items?: [];
  oneSelectPerGroup?: boolean;
  onSelect?: (
    itemIndex: number,
    item: SelectableItemType,
    parent: SelectableItemListType
  ) => void;
  selectedItems?: Array<SelectableItemListType>;
}

export default function MultiSelectableItem(props: MultiSelectableItemType) {
  const {
    company: { color },
  } = useRecoilValue(authAtom);
  const { items, onSelect, selectedItems, oneSelectPerGroup } = props;

  return (
    <>
      {items?.map((selectableItemList: SelectableItemListType, key: number) => (
        <React.Fragment key={String(key)}>
          <InputLabel label={selectableItemList.title} />

          <View
            style={{
              ...css.wrap,
              marginBottom: 20,
              ...css.rRowCenterAlign,
            }}
          >
            {selectableItemList?.items?.map(
              (selectableItem: SelectableItemType, attrItemKey: number) => {
                const itemIndex = Number(
                  selectedItems?.findIndex((e) => e.id === selectableItem.id)
                );
                const isSelected = itemIndex > -1;

                const _onSelect = () => {
                  onSelect &&
                    onSelect(itemIndex, selectableItem, selectableItemList);
                };

                return (
                  <Button
                    key={String(attrItemKey)}
                    onPress={_onSelect}
                    width={"auto"}
                    title={{
                      weight: "bold",
                      value: selectableItem.title || selectableItem.value,
                    }}
                    height={30}
                    contentSeparator={4}
                    bgColor={isSelected ? color : colors.white}
                    style={{
                      marginLeft: 7,
                      borderWidth: 1,
                      marginBottom: 7,
                      paddingHorizontal: 15,
                      borderColor: isSelected
                        ? colors.theme
                        : colors.black + "10",
                      opacity: isSelected ? 1 : 0.8,
                      borderRadius: 12,
                    }}
                  />
                );
              }
            )}
          </View>
        </React.Fragment>
      ))}
    </>
  );
}
